module.exports = __webpack_public_path__ + "static/media/appnameNegative.e8db1406.png";